
import { defineComponent } from 'vue'
import Listbox from 'primevue/listbox'
import ProfileAttributesManagementDescriptor from './ProfileAttributesManagementDescriptor.json'
import { iAttribute } from './ProfileAttributesManagement'

export default defineComponent({
    name: 'profile-attributes-list-box',
    components: {
        Listbox
    },
    emits: ['selectedAttribute', 'deleteAttribute'],
    props: {
        attributes: Object,
        loading: Boolean
    },
    watch: {
        attributes: {
            handler: function(attr) {
                this.listAttributes = attr
            }
        },
        loading: {
            handler: function(l) {
                this.load = l
            }
        }
    },
    data() {
        return {
            load: false as Boolean,
            listAttributes: [] as iAttribute[],
            selectedAttribute: null as iAttribute | null,
            profileAttributesManagementDescriptor: ProfileAttributesManagementDescriptor
        }
    },
    methods: {
        deleteAttribute(attributeId: number) {
            this.$emit('deleteAttribute', attributeId)
        },
        onAttributeSelect(event: any) {
            this.$emit('selectedAttribute', event.value)
        }
    }
})
